module.exports = __webpack_public_path__ + "static/media/wheatgreen.14634306.svg";